var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.firstAid)?_c('div',[_vm._v(_vm._s(_vm.$t("medkitlogs.yes")))]):_c('div',[_vm._v(_vm._s(_vm.$t("medkitlogs.no")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }